<template>
    <v-card>
        <v-card-title class="text-h5">Claim {{ athlete.name }} Profile</v-card-title>

        <v-card-text>
            <v-row v-if="error" align="center" class="mx-0 mt-4">
                <v-alert border="left" colored-border type="error" elevation="2">
                    {{ error }}
                </v-alert>
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-text-field
                    v-model="form.usag_number"
                    type="number"
                    :rules="usagNumberRules"
                    label="USAG Number"
                    prepend-icon="mdi-pound"
                    required
                />
            </v-row>

            <v-row align="center" class="mx-0 mt-4">
                <v-menu
                    ref="birthdatePicker"
                    v-model="birthdatePicker.menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template #activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.birthdate"
                            label="Birthdate"
                            :rules="birthdateRules"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="form.birthdate"
                        :active-picker.sync="birthdatePicker.active"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="saveBirthdate"
                    ></v-date-picker>
                </v-menu>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer />
            <v-btn @click.prevent="$emit('close')"> Cancel </v-btn>
            <v-btn color="primary" @click.prevent="submit"> Claim </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Athlete from '@/Models/Athlete.js';

export default {
    name: 'ClaimProfileModal',

    props: {
        athlete: {
            type: Athlete,
            required: true,
        },
    },

    data() {
        return {
            error: null,

            form: {
                type: 'athlete',
                athlete_id: this.athlete.id,
                usag_number: null,
                birthdate: null,
            },

            birthdatePicker: {
                active: '',
                date: null,
                menu: false,
            },

            valid: true,
            usagNumberRules: [
                v => !!v || 'USAG number is required',
                v => (!!v && v.length >= 5) || 'USAG number must be valid',
            ],
            birthdateRules: [v => !!v || 'Birthdate is required'],
        };
    },

    computed: {},

    created() {},

    methods: {
        async submit() {
            try {
                await axios.post(`/affiliations?redirect=/athletes/${this.athlete.id}`, this.form);

                window.location.reload();
            } catch (e) {
                if (e.response.status === 422) {
                    this.error = e.response.data.message;
                }

                if (e.response.status === 404) {
                    this.error = 'The information provided does not match the athlete in the database.';
                }
            }
        },

        saveBirthdate(date) {
            this.$refs.birthdatePicker.save(date);
        },
    },
};
</script>
